import {SERVER_URL} from "../config";
import axios from "axios";
import {authHeader} from "../_helpers";

function getVisitedPage(params) {
    const endpoint = `${SERVER_URL}/api/v1/visited-page`;
    return axios.get(endpoint,{
        params: params,
        headers: authHeader()
    })
}

function saveVisitedPage(payload) {
    const endpoint = `${SERVER_URL}/api/v1/visited-page`;
    return axios.post(endpoint, payload, {
        headers: authHeader()
    })
}

export const visitedPageService = {
    getVisitedPage,
    saveVisitedPage
};